const waybill = {
    Contract: {
        Id: null,
        Number: null
    },
    TerminalShow: true,
    Buyer: {
        Id: null
    },
    ShowShipmentDate: true,
    Item: {
        ProductId: '',
        AmountInTonne: '',
        AmountInLitre: '',
        GrossPricePerTonne: '',
        GrossPricePerLitre: '',
        NetPricePerTonne: '',
        PricePerTonneNoVAT: '',
        tmpExcise: 0,
        TotalPriceInText: '',
        ShowAmountInLitre: true,
        VATPerTonne: '',
        VATRate: 0,
        Density: '',
        Excise: '',
        Name: '',
    },
    Driver: {
        Name: null
    },
    Empowerment: {
        Id: null,
        Number: null
    },
    Vehicle: {
        Name: null
    },
    Appendix: {
        Id: null,
        ItemDescription: null,
        Number: null
    },
    Order: {
        Id: null
    },
    Receiver: {
        Id: null
    },
    Terminal: {
        Id: null,
        Name: null
    },
    ShipmentDoneBy: "",
    ShipmentDate: '',
    Number: '',
    Status: '',
    Trailer1: '',
    Trailer2: '',
    Convoy: '',
    Carrier: '',
    ShipmentAllowedBy: '',
    WaybillNote: '',
    Seals: '',
}

export default class Waybill {
    constructor() {
        this.wayBill = {
            Contract: {
                Id: null,
                Number: null
            },
            Buyer: {
                Id: null
            },
            TerminalShow: true,
            Item: {
                ProductId: '',
                AmountInTonne: '',
                AmountInLitre: '',
                GrossPricePerTonne: '',
                GrossPricePerLitre: '',
                NetPricePerTonne: '',
                PricePerTonneNoVAT: '',
                tmpExcise: 0,
                TotalPriceInText: '',
                ShowAmountInLitre: true,
                VATPerTonne: '',
                VATRate: 0,
                Density: '',
                Excise: '',
                Name: '',
            },
            Driver: {
                Name: null
            },
            Empowerment: {
                Id: null,
                Number: null
            },
            Vehicle: {
                Name: null
            },
            Appendix: {
                Id: null,
                ItemDescription: null,
                Number: null
            },
            Order: {
                Id: null,
                Number: null
            },
            Receiver: {
                Id: null
            },
            Terminal: {
                Id: null,
                Name: null
            },
            ShowShipmentDate: true,
            ShipmentDoneBy: "",
            ShipmentDate: '',
            Number: '',
            Status: '',
            Trailer1: '',
            Trailer2: '',
            Convoy: '',
            Carrier: '',
            ShipmentAllowedBy: '',
            WaybillNote: '',
            Seals: '',
        }

    }
}


const t = () => {
    const item = {...waybill.Item}
    const _waybill = {...waybill}
    _waybill.Item = {...item}
    return _waybill
}
